import React from "react";
import {
  Hero,
  Trending_category,
} from "../../components/component";
import Meta from "../../components/Meta";
import {generalContent} from "../../content/generalContent";

const Home_1 = () => {
  return (
    <main>
      <Meta title={generalContent.registryName} />
      <Hero />
      <Trending_category />
    </main>
  );
};

export default Home_1;
